import { render } from "./DatasourceViewPage.vue?vue&type=template&id=5abeb20c"
import script from "./DatasourceViewPage.vue?vue&type=script&lang=js"
export * from "./DatasourceViewPage.vue?vue&type=script&lang=js"

import "./DatasourceViewPage.vue?vue&type=style&index=0&id=5abeb20c&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__